module.exports = __webpack_public_path__ + "img/logo.ca437eaf.png";